import { Injectable } from '@angular/core';
import { constant } from 'src/app/constant/constant';
import { environment } from 'src/environments/environment';

export interface SubChildMenu {
  state: string;
  name: string;
  type: string;
  isHovered: boolean;
  icon: string;
}

export interface ChildMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  isHovered: boolean;
  subChildMenu : SubChildMenu[];
  expanded:boolean;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  imageUrl: string;
  expanded: boolean;
  isHovered: boolean;
  childMenu?: ChildMenu[];
}


var retMenuData: Menu[] = [];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return retMenuData;
  }
  userRights: any = {};
  stationDetails: any;
  abc: any = {};
  childMenuData: ChildMenu[] = [];
  subChildMenuData: SubChildMenu[] = [];
  storeDetails: any = {};
  storeDetailsFromSession: any = {};
  shouldDisable: boolean = false;


  setAccessLinks() {

    retMenuData.length = 0;

    //IF THE USER IS NOT LOGGED IN THEN SESSION WILL BE NULL CHECKING THAT

    if (sessionStorage.getItem(constant.KEY_USER_RIGHTS)) {

      this.stationDetails = JSON.parse(sessionStorage.getItem(constant.KEY_STATION_DETAILS) || "{}");
      this.storeDetailsFromSession = sessionStorage.getItem(constant.KEY_STORE_DETAILS);
      this.storeDetails = JSON.parse(this.storeDetailsFromSession);
      this.shouldDisable = this.storeDetails.rxLink != null || this.storeDetails.primeRxCloudURL != null

      //FIRST GET THE RIGHTS FROM THE SESSION AND THEN ADD LINKS
      this.userRights = JSON.parse(sessionStorage.getItem(constant.KEY_USER_RIGHTS) || "{}");

      let webAdminRight = this.userRights.webRights.webAdministrativeFunction;

      //#region Dashboard
      if(this.shouldDisable) {
      retMenuData.push({ state: 'dashboard', type: 'link', name: 'Dashboard', icon: 'grain', expanded: false, imageUrl: 'assets/images/icons/dashboard-icon-orange-small.png', isHovered: false });
    }
    //#endregion

    //#region Administrative
    this.childMenuData = [];

    // if (this.stationDetails != null && this.stationDetails != undefined && this.stationDetails != "") {
      //storeView

      if (this.userRights && webAdminRight.webAdminCompanySetup != null && (webAdminRight.webAdminCompanySetup.add == true || webAdminRight.webAdminCompanySetup.update == true || webAdminRight.webAdminCompanySetup.delete == true || webAdminRight.webAdminCompanySetup.search == true)) {
        this.childMenuData.push({ state: 'store', type: 'link', name: 'Store', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }

      if (this.userRights && webAdminRight.webAdminUser != null && (webAdminRight.webAdminUser.add == true || webAdminRight.webAdminUser.update == true || webAdminRight.webAdminUser.delete == true || webAdminRight.webAdminUser.search == true) && this.shouldDisable) {

        this.childMenuData.push({ state: 'user', type: 'link', name: 'Users', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }

      // if (this.userRights && webAdminRight.webAdminCustomer != null && (webAdminRight.webAdminCustomer.add == true || webAdminRight.webAdminCustomer.update == true || webAdminRight.webAdminCustomer.delete == true || webAdminRight.webAdminCustomer.search == true) && this.shouldDisable) {

      //   this.childMenuData.push({ state: 'reports/customer/customer', type: 'link', name: 'Customers', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      // }

      if (this.userRights && webAdminRight.webAdminRole != null && (webAdminRight.webAdminRole.add == true || webAdminRight.webAdminRole.update == true || webAdminRight.webAdminRole.delete == true || webAdminRight.webAdminRole.search == true) && this.shouldDisable) {

        this.childMenuData.push({ state: 'role', type: 'link', name: 'Roles', icon: 'view_headline', isHovered: false, expanded:false, subChildMenu: [] });
      }

      // if (this.userRights && webAdminRight.manageRights == true && this.shouldDisable) {

      //   this.childMenuData.push({ state: 'manage-rights', type: 'link', name: 'Manage Rights', icon: 'tab', isHovered: false, subChildMenu: [] });
      // }

      //Commenting reset station as it is not required
      // if (this.userRights && webAdminRight.resetStation == true && this.shouldDisable) {

      //   this.childMenuData.push({ state: 'reset-station', type: 'link', name: 'Reset Station', icon: 'tab', isHovered: false, subChildMenu: [] });
      // }

      if (this.userRights && webAdminRight.webTax != null && (webAdminRight.webTax.add == true || webAdminRight.webTax.update == true || webAdminRight.webTax.delete == true || webAdminRight.webTax.search == true) && this.shouldDisable) {

        this.childMenuData.push({ state: 'tax', type: 'link', name: 'Taxes', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }

      // if (this.userRights && webAdminRight.webScheduler && this.shouldDisable) {

      //   this.childMenuData.push({ state: 'scheduler', type: 'link', name: 'Scheduler', icon: 'tab', isHovered: false, subChildMenu: [] });
      // }

      if (this.childMenuData.length > 0) {
        retMenuData.push({ state: 'administrative', type: 'text', name: 'Admin Function', icon: 'admin_panel_settings', expanded: false, imageUrl: 'assets/images/icons/icon-admin.png', isHovered: false, childMenu: this.childMenuData });
      }

      //}
      //#endregion Administrative

      //#region EOD
      this.childMenuData = [];

      if (this.userRights && webAdminRight.EOD == true && this.shouldDisable) {

        this.childMenuData.push({ state: 'EOD-Reports', type: 'link', name: 'EOD Reports', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }

      if (this.userRights && webAdminRight.webEODHistory == true && this.shouldDisable) {

        this.childMenuData.push({ state: 'EOD-History', type: 'link', name: 'EOD History', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }

      if (this.childMenuData.length > 0) {
        retMenuData.push({ state: 'EOD', type: 'text', name: 'End of Day (EOD)', icon: 'grain', expanded: false, imageUrl: 'assets/images/icons/icon-eod.png', isHovered: false, childMenu: this.childMenuData });
      }
      //#endregion EOD

      //#region Receipt Design
       this.subChildMenuData = [];
        if (this.userRights && webAdminRight.receiptDesign == true && this.shouldDisable) {
          this.childMenuData = [];
          // Add the receipt design menu if the user has the appropriate rights
          if (this.userRights) {
            //this.childMenuData.push({ state: 'receipt-designer', type: 'link', name: 'Sale Receipt', icon: 'receipt_long', isHovered: false, subChildMenu: [] });
            // /receipts
            this.childMenuData.push({ state: 'receipts', type: 'link', name: 'Sale Receipts', icon: 'receipt_long', isHovered: false, expanded:false, subChildMenu: [] });
          }

          // Add receipt design data to retMenuData if childMenuData is populated
          if (this.userRights && this.childMenuData.length > 0) {
            retMenuData.push({
              state: 'Receipt Design',
              type: 'text',
              name: 'Customize Receipts/Tags',
              icon: 'Receipt Design',
              expanded: false,
              imageUrl: 'assets/images/icons/receiptDesign.png',
              isHovered: false,
              childMenu: this.childMenuData
            });
          }
        }
      //#endregion

      //#region Item Function
      this.childMenuData = [];

      if (this.userRights && webAdminRight.webAdminItem != null && (webAdminRight.webAdminItem.add == true || webAdminRight.webAdminItem.update == true || webAdminRight.webAdminItem.delete == true || webAdminRight.webAdminItem.search == true) && this.shouldDisable) {


        this.childMenuData.push({ state: 'item', type: 'link', name: 'Items', icon: 'view_comfy', isHovered: false, expanded:false, subChildMenu: [] });
      }

      if (this.userRights && webAdminRight.webAdminItemDepartment != null && (webAdminRight.webAdminItemDepartment.add == true || webAdminRight.webAdminItemDepartment.update == true || webAdminRight.webAdminItemDepartment.delete == true || webAdminRight.webAdminItemDepartment.search == true) && this.shouldDisable) {

        this.childMenuData.push({ state: 'item-department', type: 'link', name: 'Item Departments', icon: 'view_list', isHovered: false, expanded:false, subChildMenu: [] });
      }

      if (this.userRights && webAdminRight.webItemMonitoringCategory == true && this.shouldDisable) {

        this.childMenuData.push({ state: 'monitoring-category', type: 'link', name: 'Monitoring Categories', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }

      // if (this.userRights && webAdminRight.webItemPriceLogLabel == true && this.shouldDisable) {
      //   this.childMenuData.push({ state: 'itemPriceLogLabels', type: "link", name: 'Item Price Log Labels', icon: 'tab', isHovered: false, subChildMenu: [] });
      // }


      if (this.userRights && webAdminRight.itemPriceHistory == true && this.shouldDisable) {

        this.childMenuData.push({ state: 'itemPriceHistory', type: 'link', name: 'Item Price History', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }

      if (this.userRights && webAdminRight.webQuickAddOrder != null && (webAdminRight.webQuickAddOrder.add == true || webAdminRight.webQuickAddOrder.update == true || webAdminRight.webQuickAddOrder.delete == true || webAdminRight.webQuickAddOrder.search == true) && this.shouldDisable) {

        this.childMenuData.push({ state: 'quickAddItems', type: 'link', name: 'Quick Add Items', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }

      //Suggestive selling
      if (this.userRights && webAdminRight.suggestiveSelling && this.shouldDisable)
        this.childMenuData.push({ state: 'suggestiveselling', type: 'link', name: 'Suggestive Selling', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });

      // if (this.userRights && webAdminRight.webQuickAddGroup != null && (webAdminRight.webQuickAddGroup.add == true || webAdminRight.webQuickAddGroup.update == true || webAdminRight.webQuickAddGroup.delete == true || webAdminRight.webQuickAddGroup.search == true) && this.shouldDisable) {

      //   this.childMenuData.push({ state: 'quickAddGroup', type: 'link', name: 'Quick Add Groups', icon: 'tab', isHovered: false, subChildMenu: [] });
      // }

      if (this.childMenuData.length > 0) {
        retMenuData.push({ state: 'item', type: 'text', name: 'Item Function', icon: 'grain', expanded: false, imageUrl: 'assets/images/icons/icon-item.png', isHovered: false, childMenu: this.childMenuData });
      }

      //#endregion Item Function

      //#region Inventory Files
      this.childMenuData = [];
       this.subChildMenuData = [];

      if (this.userRights && webAdminRight.webNonEdiVendor != null && (webAdminRight.webNonEdiVendor.add == true || webAdminRight.webNonEdiVendor.update == true || webAdminRight.webNonEdiVendor.delete == true || webAdminRight.webNonEdiVendor.search == true) && this.shouldDisable) {

        //subchilds
        if (this.userRights && webAdminRight.webPurchaseOrder == true && this.shouldDisable) {
          this.subChildMenuData.push({ state: 'purchaseOrder', type: 'link', name: 'Purchase Order', icon: 'tab', isHovered: false });
        }

        if (this.userRights && webAdminRight.webPurchaseOrderAck == true && this.shouldDisable) {
          this.subChildMenuData.push({ state: 'edi/purchaseOrderAck', type: 'link', name: 'Purchase Order Ack', icon: 'tab', isHovered: false });
        }

        if (this.userRights && webAdminRight.web810FileProcessing == true && this.shouldDisable) {
          this.subChildMenuData.push({ state: 'edi/file-upload', type: 'link', name: '810 File Processing', icon: 'tab', isHovered: false });
        }

        if (this.userRights && webAdminRight.WebAdminInventoryReceived == true && this.shouldDisable) {
          this.subChildMenuData.push({ state: 'edi/inventoryReceived', type: 'link', name: 'EDI Inventory Received', icon: 'tab', isHovered: false });
        }
        //subchilds

        this.childMenuData.push({ state: 'EDI', type: 'text', name: 'EDI', icon: 'tab', isHovered: false, expanded: false, subChildMenu: this.subChildMenuData });
      }

      this.subChildMenuData = [];

      if (this.userRights && webAdminRight.webNonEdiVendor != null && (webAdminRight.webNonEdiVendor.add == true || webAdminRight.webNonEdiVendor.update == true || webAdminRight.webNonEdiVendor.delete == true || webAdminRight.webNonEdiVendor.search == true) && this.shouldDisable) {

        if (this.userRights && webAdminRight.webManualFileUpdate == true && this.shouldDisable) {
          this.subChildMenuData.push({ state: 'non-edi/manual-file-update', type: 'link', name: 'Manual File Update', icon: 'tab', isHovered: false });
        }

         if (this.userRights && webAdminRight.webNonEdiVendor != null && (webAdminRight.webNonEdiVendor.add == true || webAdminRight.webNonEdiVendor.update == true || webAdminRight.webNonEdiVendor.delete == true || webAdminRight.webNonEdiVendor.search == true) && this.shouldDisable) {
        this.subChildMenuData.push({ state: 'non-edi/vendor', type: 'link', name: 'Vendors', icon: 'tab', isHovered: false });
      }


        this.childMenuData.push({ state: 'Non-EDI', type: 'text', name: 'Non-EDI', icon: 'tab', isHovered: false, expanded:false, subChildMenu: this.subChildMenuData });
      }

      this.subChildMenuData = [];

      if (this.userRights && this.childMenuData.length > 0) {
        retMenuData.push({ state: 'inventory', type: 'text', name: 'Inventory Files', icon: 'Inventory Files', expanded: false, imageUrl: 'assets/images/icons/icon-inventory.png', isHovered: false, childMenu: this.childMenuData });
      }

      this.subChildMenuData = [];

      //#endregion

      //#region Reports

      this.childMenuData = [];

      //#region Sales Reports
      this.childMenuData = [];

      // Sales Reports
      let salesReports: SubChildMenu[] = [];
      if (this.userRights && webAdminRight.webCustomerSalesReport == true && this.shouldDisable) {
        salesReports.push({ state: 'reports/sales/sales-report-customer', type: 'link', name: 'Sale By Customer', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.webDepartmentSalesReport == true && this.shouldDisable) {
        salesReports.push({ state: 'reports/sales/sales-report-department', type: 'link', name: 'Sale By Department', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.webSalesItemReport == true && this.shouldDisable) {
        salesReports.push({ state: 'reports/sales/sales-report-by-item', type: 'link', name: 'Sale By Item', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.webSalesPaymentReport == true && this.shouldDisable) {
        salesReports.push({ state: 'reports/sales/sales-report-by-payment', type: 'link', name: 'Sale By Payment', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.webSalesUserReport == true && this.shouldDisable) {
        salesReports.push({ state: 'reports/sales/sales-report-by-user', type: 'link', name: 'Sale By User', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.suggestiveSelling == true && this.shouldDisable) {
        salesReports.push({ state: 'reports/sales/salesBySuggestion', type: 'link', name: 'Sale By Suggestion', icon: 'tab', isHovered: false });
      }
      // Add Payment Report here
      if (this.userRights && webAdminRight.webPaymentReport == true && this.shouldDisable) {
        salesReports.push({ state: 'reports/sales/payment-report', type: 'link', name: 'Pending Transactions', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.storeView) {
        salesReports.push({ state: 'reports/sales/store-view', type: 'link', name: 'Store View', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.webTransactionReport == true && this.shouldDisable) {
        salesReports.push({ state: 'reports/sales/transaction-report', type: 'link', name: 'Transaction Details', icon: 'tab', isHovered: false });
      }
      salesReports.push({ state: 'reports/sales/transaction-audit-report', type: 'link', name: 'Transactions Receipts', icon: 'tab', isHovered: false });
      if (salesReports.length > 0) {
        this.childMenuData.push({ state: 'sales-reports', type: 'text', name: 'Sales Reports', icon: 'tab', isHovered: false, expanded: false, subChildMenu: salesReports });
      }
      //#endregion Sales Reports

      // Customer Reports
      let customerReports: SubChildMenu[] = [];
      if (
        this.userRights &&
        webAdminRight.webAdminCustomer != null &&
        (webAdminRight.webAdminCustomer.add == true ||
          webAdminRight.webAdminCustomer.update == true ||
          webAdminRight.webAdminCustomer.delete == true ||
          webAdminRight.webAdminCustomer.search == true) &&
        this.shouldDisable
      ) {
        customerReports.push({ state: 'reports/customer/customer', type: 'link', name: 'Customers', icon: 'tab', isHovered: false });
      }
      if (customerReports.length > 0) {
        this.childMenuData.push({ state: 'customer-reports', type: 'text', name: 'Customer Reports', icon: 'tab', isHovered: false, expanded: false, subChildMenu: customerReports });
      }

      // Inventory Reports
      let inventoryReports: SubChildMenu[] = [];
      if (this.userRights && webAdminRight.webInventoryRecdReport == true && this.shouldDisable) {
        inventoryReports.push({ state: 'reports/inventory/inventory-received-report', type: 'link', name: 'Inventory Received', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.webInventoryStatusReport == true && this.shouldDisable) {
        inventoryReports.push({ state: 'reports/inventory/inventory-status-report', type: 'link', name: 'Inventory Status', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.webMissingItemsReport == true && this.shouldDisable) {
        inventoryReports.push({ state: 'reports/inventory/missing-item-report', type: 'link', name: 'Missing Items', icon: 'tab', isHovered: false });
      }
      if (inventoryReports.length > 0) {
        this.childMenuData.push({ state: 'inventory-reports', type: 'text', name: 'Inventory Reports', icon: 'tab', isHovered: false, expanded: false, subChildMenu: inventoryReports });
      }

      // Pricing Reports
      let pricingReports: SubChildMenu[] = [];
      if (this.userRights && webAdminRight.webItemPriceChangeReport == true && this.shouldDisable) {
        pricingReports.push({ state: 'reports/pricing/item-price-change-log-report', type: 'link', name: 'Item Price Change', icon: 'tab', isHovered: false });
      }
      if (this.userRights && webAdminRight.webPriceOverrideReport == true && this.shouldDisable) {
        pricingReports.push({ state: 'reports/pricing/price-override-report', type: 'link', name: 'Price Overridden', icon: 'tab', isHovered: false });
      }
      if (pricingReports.length > 0) {
        this.childMenuData.push({ state: 'pricing-reports', type: 'text', name: 'Pricing Reports', icon: 'tab', isHovered: false, expanded: false, subChildMenu: pricingReports });
      }

      // Financial Reports
      let financialReports: SubChildMenu[] = [];
      if (this.userRights && webAdminRight.webPayOutReport == true && this.shouldDisable) {
        financialReports.push({ state: 'reports/financial/payout-report', type: 'link', name: 'Payout Details', icon: 'tab', isHovered: false });
      }
      financialReports.push({ state: 'reports/financial/sales-tax-report', type: 'link', name: 'Sales Tax', icon: 'tab', isHovered: false });

      if (this.userRights && webAdminRight.webRecon == true && this.shouldDisable) {
        financialReports.push({ state: 'reports/financial/credit-card-transaction', type: 'link', name: 'Credit Card Transaction', icon: 'tab', isHovered: false });
      }
      if (financialReports.length > 0) {
        this.childMenuData.push({ state: 'financial-reports', type: 'text', name: 'Financial Reports', icon: 'tab', isHovered: false, expanded: false, subChildMenu: financialReports });
      }

      // Compliance Reports
      let complianceReports: SubChildMenu[] = [];
      complianceReports.push({ state: 'reports/compliance/nplex-items-report', type: 'link', name: 'Nplex', icon: 'tab', isHovered: false });
      if (complianceReports.length > 0) {
        this.childMenuData.push({ state: 'compliance-reports', type: 'text', name: 'Compliance Reports', icon: 'tab', isHovered: false, expanded: false, subChildMenu: complianceReports });
      }

      // Finally, push the grouped reports to the main menu if any exist
      if (this.childMenuData.length > 0) {
        retMenuData.push({
          state: 'reports',
          type: 'text',
          name: 'Reports',
          icon: 'table_chart',
          expanded: false,
          imageUrl: 'assets/images/icons/icon-reports.png',
          isHovered: false,
          childMenu: this.childMenuData
        });
      }
      //#endregion Reports

      //#region CLP
      this.childMenuData = [];
      if (this.userRights && webAdminRight.webClpSettings == true && this.shouldDisable) {
        this.childMenuData.push({ state: 'clp-settings', type: "link", name: 'CLP Settings', icon: 'tab', isHovered: false, expanded:false, subChildMenu: [] });
      }
      //EPPOS-3640
      // if (this.userRights && this.childMenuData.length > 0) {
      //   retMenuData.push({ state: 'clp', type: 'text', name: 'CLP', icon: 'badge', expanded: false, imageUrl: 'assets/images/icons/icon-edi.png', isHovered: false, childMenu: this.childMenuData });
      // }
      //#endregion CLP

      //#region Label
      //EPPOS-4021-Commented to avoid issues because of fabric upgradation
      // this.childMenuData = [];
      // if (this.stationDetails != null && this.stationDetails != undefined && this.stationDetails != "") {

      //   if (this.userRights && webAdminRight.webLabelDesign == true && this.shouldDisable) {
      //     this.childMenuData.push({ state: 'labelDesign', type: 'link', name: 'Label Design', icon: 'tab', isHovered:false, subChildMenu: [] });
      //   }

      // }
      // if (this.userRights && this.childMenuData.length > 0) {
      //   retMenuData.push({ state: 'Label Design', type: 'text', name: 'Label Design', icon: 'Label Design', expanded: false, imageUrl: 'assets/images/icons/icon-label.png', isHovered: false, childMenu: this.childMenuData });
      // }
      //#endregion Label


      for (let menu of retMenuData) {
        menu.expanded = false; // Reset all menu items first
      }

      const expandedItem = sessionStorage.getItem('expandedItem');
      const isExpandedItem = sessionStorage.getItem('isExpandedItem');

     const childItem = sessionStorage.getItem('Child');
     const isExpandedChild = sessionStorage.getItem('expandedStateChild');

      if (expandedItem && isExpandedItem) {
        try {
          const item = JSON.parse(expandedItem);
          const state = JSON.parse(isExpandedItem ?? 'false') === true;
          const child = childItem ? JSON.parse(childItem) : null;
          const childState = JSON.parse(isExpandedChild ?? 'false') === true;

          if (state) {
            const targetMenu = retMenuData.find(menu => menu.name === item.name);
            if (targetMenu) {
              targetMenu.expanded = true;

              if (child && childState && targetMenu.childMenu) {
                const targetChild = targetMenu.childMenu.find(c => c.name === child.name);
                if (targetChild) {
                  targetChild.expanded = true;
                }
              }
            }
          }
        } catch (error) {
          console.error("Error parsing session storage data:", error);
        }
      }

      // if (expandedItem && isExpandedItem) {
      //   try {
      //     const Item = JSON.parse(expandedItem);
      //     const state = JSON.parse(isExpandedItem) === true; // Ensure it's a boolean



      //     if (state) {
      //       const targetMenu = retMenuData.find(menu => menu.name === Item.name);
      //       if (targetMenu) {
      //         targetMenu.expanded = true;

      //         if(targetMenu.childMenu){
      //           const targetChild = retMenuData.find(menu => menu.childMenu.name == Child.name){
      //             targetMenu.childMenu.expanded =true;
      //           }
      //         }


      //       }
      //     }
      //   } catch (error) {
      //     console.error("Error parsing session storage data:", error);
      //   }
      // }






      // }
      // else {
      //   this.childMenuData.push({ state: 'store', type: 'link', name: 'Store', icon: 'tab', isHovered:false, subChildMenu: [] });
      //   if (this.childMenuData.length > 0) {
      //     retMenuData.push({ state: 'administrative', type: 'text', name: 'Admin Function', icon: 'admin_panel_settings', expanded: false, imageUrl: 'assets/images/icons/icon-edi.png', isHovered: false, childMenu: this.childMenuData });
      //   }
      // }
    }
  }
}
